import Icon from '@ant-design/icons'
import { Select } from 'antd'
import styled from 'styled-components'
import { cssLimitLines } from 'styles'

export const StyledIcon = styled(Icon)`
  &.anticon-label {
    margin-right: 8px;
  }
`

export const StyledTagClose = styled.span`
  display: flex;
  width: 15px;
  height: 15px;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme?.colors?.gray400};
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  font-size: 10px;
  line-height: 1;
  transition: 0.25s linear all;
  &:hover {
    background-color: ${({ theme }) => theme?.colors?.gray700};
  }
`

export const StyledTagLabel = styled.span`
  color: ${({ theme }) => theme?.colors?.gray700 || '#404040'};
  flex: 1;
  min-width: 0;
  max-width: 100%;
  display: block !important;
  ${cssLimitLines(3)}
`

export const StyledTag = styled.span`
  position: relative;
  z-index: 111;
  display: flex;
  align-items: center;
  padding: 2px 8px 2px 12px;
  border: 1px solid ${({ theme }) => theme?.colors?.neutral100 || '#E4E8EC'};
  margin-top: 2px;
  margin-right: 8px;
  margin-bottom: 2px;
  border-radius: 32px;
  ${StyledTagLabel} {
    + ${StyledTagClose} {
      margin-left: 8px;
    }
  }
`

export const StyledSelect = styled(Select)`
  .ant-select-selection-search {
    margin-inline-start: 2px;
  }
`
